module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(groups, function(group) { 
__p+='\n	';

		var visible_count = 0;
		for(var i = 0, tag; tag = group.tags[i]; ++i) {
			if ( !tag.count ) { continue; }
			visible_count++;
		}
		if ( visible_count === 0 ) return; // Aus der each groups Loop ausbrechen
	
__p+='\n\n<div class="group tag_group_'+
((__t=( group.index ))==null?'':__t)+
'">\n	<h4>'+
((__t=( group.name ))==null?'':__t)+
'</h4>\n	';

		var visible_count = 0;
		var treshhold = registry("CollapseTagGroupsTreshhold");
		if ( group.index == 51 ) treshhold = 50; // Ortsteile in Oberstdorf

		var visible_tags = _.filter(group.tags, function(tag) { return tag.count > 0 });
		/* Falls es nur ein Item als "Mehr" gibt, setzen wir das Limit für die Gruppe einfach hoch */
		if ( visible_tags.length === treshhold + 1 ) { treshhold++; }
	
__p+='\n	';
 _.each(visible_tags, function(tag, i) { 
__p+='\n		';
 i = i + 1 
__p+='\n		';
 visible_count++; 
__p+='\n\n			<span data-id="'+
((__t=( tag.id ))==null?'':__t)+
'"\n				  data-group="'+
((__t=( group.name ))==null?'':__t)+
'"\n				  title="'+
((__t=( tag.info ))==null?'':__t)+
'"\n				  class="tag '+
((__t=( isSelected(tag.id) ? 'checked' : '' ))==null?'':__t)+
' '+
((__t=( tag.count === 0 ? 'disabled' : '' ))==null?'':__t)+
' '+
((__t=( i > treshhold ? 'hidden' : '' ))==null?'':__t)+
'">\n				<label for="tag_'+
((__t=( tag.id ))==null?'':__t)+
'">\n					'+
((__t=( tag.tag ))==null?'':__t)+
'\n					';
 if ( tag.count !== null ) { 
__p+='\n						';
 if ( tag.count > 0 ) { 
__p+='\n						<span class="count">'+
((__t=( tag.count ))==null?'':__t)+
'</span>\n						';
 } 
__p+='\n					';
 } 
__p+='\n				</label>\n				<br/>\n			</span>\n\n	';
 }) 
__p+='\n\n	';
 if ( visible_count > treshhold ) { 
__p+='\n	<span class="more" data-group="'+
((__t=( group.index ))==null?'':__t)+
'">\n		'+
((__t=( __("sidebar_more") ))==null?'':__t)+
'\n	</span>\n	';
 } 
__p+='\n\n</div>\n';
 }) 
__p+='\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/engine/SidebarTemplate.html
// module id = 63
// module chunks = 0